import { GlobalDesignGroupAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';

export const cornerGrouping: GlobalDesignGroupAction['grouping'] = {
  getGroupingStrategy: (editorPointers, getHost, componentsAPI) => {
    return () => {
      return groupByGroupDefinitions(
        editorPointers,
        'cornerStyles',
        getHost,
        componentsAPI,
      );
    };
  },
};
